export default __webpack_public_path__ + "static/media/gallery-frogs_00.cefadf27.jpg";